
































import gql from 'graphql-tag';
import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { BAlert } from 'bootstrap-vue';
import { get } from 'lodash';
import GenericCard from '@/components/cards/GenericCard.vue';
import { ModalSize } from '@/components/zen_modal/types';
import { Alert } from '@/components/global_alerts/types';
import { Dashboard, DashboardTitleErrors } from './types';
import { PATHS } from '@/router/paths';
import DashboardCardTitle, { DashboardCardTitleType } from './DashboardCardTitle.vue';
import { DASHBOARD_LIST_QUERY } from '@/pages/dashboards/DashboardListPage.vue';

const CREATE_DASHBOARD_MUTATION = gql`
  mutation CreateDashboard($input: CreateDashboardInput!) {
    result: createDashboard(input: $input) {
      dashboard: result {
        id
        nodeId: id
        title {
          value
        }
        updatedAt {
          value
        }
      }
    }
  }
`;

const UPDATE_DASHBOARD_MUTATION = gql`
  mutation UpdateDashboard($id: ID!, $input: UpdateDashboardInput!) {
    result: updateDashboard(id: $id, input: $input) {
      dashboard: result {
        id
        nodeId: id
        title {
          value
        }
        updatedAt {
          value
        }
      }
    }
  }
`;

export default Vue.extend({
  name: 'DashboardCard',
  components: {
    GenericCard,
    BAlert,
    DashboardCardTitle,
  },
  props: {
    cardTitle: {
      type: String,
      required: false,
      default: '',
    },
    dashboard: {
      type: Object as PropType<Dashboard>,
      default: () => {},
    },
    isOnPage: {
      type: Boolean,
      default: false,
    },
  },
  apollo: {
    ownerGroupId: {
      query: gql`
        query GetCurrentUserGroupId {
          currentUser {
            id
            privateGroup {
              value {
                id
              }
            }
          }
        }
      `,
      update(result) {
        // TODO: Remove after ac_groups is enabled
        this.currentUserId = get(result, 'currentUser.id');
        return get(result, 'currentUser.privateGroup.value.id');
      },
    },
  },
  data() {
    return {
      ownerGrouopId: null,
      currentUserId: null,
      title: <string>'',
      alerts: <Alert[]>[],
      saving: false,
      dashboardTitleType: DashboardCardTitleType.DASHBOARD,
      titleValidationLoading: false,
      titleErrors: <DashboardTitleErrors>{
        titleExists: false,
        titleTooLong: false,
      },
    };
  },
  computed: {
    ...mapGetters(['featureFlags']),
    isEdit() {
      return !!this.dashboard;
    },
    dashboardId() {
      return this.isEdit ? this.dashboard.id : null;
    },
    mutationQuery() {
      return this.isEdit ? UPDATE_DASHBOARD_MUTATION : CREATE_DASHBOARD_MUTATION;
    },
    ownerIdLoaded() {
      return !!(this.featureFlags && (this.ownerGroupId || this.currentUserId));
    },
  },
  created() {
    if (this.dashboard) {
      this.title = this.dashboard.title;
    }
    if (!this.isOnPage) {
      this.changeModalSize(ModalSize.Small);
    }
  },
  methods: {
    ...mapActions({
      changeModalSize: 'modals/changeSize',
      cancelModal: 'modals/cancel',
      confirmModal: 'modals/confirm',
      showAlert: 'alerts/show',
    }),
    onCancel() {
      if (this.isOnPage) {
        this.$router.push(PATHS.DASHBOARD.LIST.path);
      } else {
        this.cancelModal();
      }
    },
    async save() {
      if (!this.isValid()) return;

      const { isEdit, title, dashboard } = this;

      const mutation = isEdit ? UPDATE_DASHBOARD_MUTATION : CREATE_DASHBOARD_MUTATION;

      // TODO: remove after ac_groups is enabled
      const owners = this.featureFlags.ac_groups
        ? {
            ownersGroup: [this.ownerGroupId],
          }
        : {
            owners: [this.currentUserId],
          };

      const variables = isEdit
        ? {
            input: {
              title,
              ...owners,
            },
            id: dashboard.id,
          }
        : {
            input: {
              title,
              settings: '{}',
              layout: '{}',
              ...owners,
            },
          };

      try {
        this.saving = true;

        const response = await this.$apollo.mutate({
          mutation,
          variables,
          refetchQueries: [{ query: DASHBOARD_LIST_QUERY }],
        });

        const dashboard = get(response, 'data.result.dashboard');

        this.showAlert({
          type: 'success',
          message: `Dashboard ${this.isEdit ? 'updated' : 'added'} successfully`,
        });

        if (!isEdit) {
          this.$router.push(`${PATHS.DASHBOARD.LIST.path}/${dashboard.nodeId}`);
        } else {
          this.confirmModal(dashboard);
        }
      } catch {
        this.showAlert({
          type: 'error',
          message: `Failed ${this.isEdit ? 'updating existing' : 'adding new'} Dashboard`,
        });
      } finally {
        this.saving = false;
      }
    },
    isValid() {
      this.alerts = !this.title.trim() ? [this.getError('Field Title is required.')] : [];
      if (this.titleErrors.titleExists) {
        this.alerts.push(this.getError('Title already exists.'));
      }
      if (this.titleErrors.titleTooLong) {
        this.alerts.push(this.getError('Title too long.'));
      }
      return !this.alerts.length;
    },
    getError(message: string) {
      return {
        type: 'error',
        message,
      };
    },
    onTitleValidationLoading(loading) {
      this.titleValidationLoading = loading;
    },
  },
});
